import { createApi } from "@reduxjs/toolkit/query/react";
import toast from "react-hot-toast";
import { customBaseQuery } from "store/utils";
import { COMPANY_SETTING_BY_ID } from "utils/apiRoutes";

export const companySettingsApi = createApi({
  reducerPath: "companySettingsApi",
  baseQuery: customBaseQuery,
  tagTypes: ["CompanySettings"],
  endpoints: (builder) => ({
    getCompanySettings: builder.query<any, string | number>({
      query: (id) => COMPANY_SETTING_BY_ID(id),
      providesTags: (result, error, id) => [{ type: "CompanySettings", id }],
      async onQueryStarted(id, { dispatch, queryFulfilled, getState }) {
        const { data } = await queryFulfilled;

        const state = getState() as any;
        const commonFilter = state.table?.commonFilter;

        const updatedFilter = Object.entries(commonFilter).map(([key, val]) => {
          const v = val as Record<string, any>;
          return {
            [key]: {
              ...v,
              showNonZero: data?.showZeroHoldingTables,
            },
          };
        });

        const combinedObject = updatedFilter.reduce(
          (acc, obj) => {
            const item = Object.keys(obj)[0];
            acc[item] = obj[item];
            return acc;
          },
          {} as typeof commonFilter,
        );

        dispatch({
          type: "table/updateAllTableFilters",
          payload: combinedObject,
        });
      },
    }),
    updateCompanySettings: builder.mutation<any, { id: string; body: any }>({
      query: ({ id, body }) => ({
        url: COMPANY_SETTING_BY_ID(id),
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "CompanySettings", id },
      ],
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          toast.success(
            data?.data?.message || "Action Performed Successfully.",
          );
        } catch (err: any) {
          toast.error(
            err?.response?.data?.message ||
              "Something went wrong, please try again.",
          );
        }
      },
    }),
  }),
});

export const { useGetCompanySettingsQuery, useUpdateCompanySettingsMutation } =
  companySettingsApi;
